import { ColorOptions } from "../types";
import { THEME } from "./theming";
/* Color Options and the contrasting colors have been defined by Design.
If you need to change the color or add to the collection contact Design to get
the correct definition. */
var MAPPED_CONTRAST_COLORS = new Map([
    [ColorOptions.Red, THEME.palette.error.light.color],
    [ColorOptions.LightGrey, THEME.palette.gray.smoke.color],
    [ColorOptions.Blue, THEME.palette.primary.light.color],
    [ColorOptions.Green, THEME.palette.success.light.color],
    [ColorOptions.Yellow, THEME.palette.warning.light.color],
    [ColorOptions.InstructorIssues, THEME.palette.instructorIssues.light.color],
    [ColorOptions.ResourceIssues, THEME.palette.resourceIssues.light.color],
]);
var MAPPED_COLORS = new Map([
    [ColorOptions.Red, THEME.palette.error.dark.color],
    [ColorOptions.LightGrey, THEME.palette.gray.slate.color],
    [ColorOptions.Blue, THEME.palette.primary.dark.color],
    [ColorOptions.Green, THEME.palette.success.dark.color],
    [ColorOptions.Yellow, THEME.palette.warning.dark.color],
    [ColorOptions.InstructorIssues, THEME.palette.instructorIssues.dark.color],
    [ColorOptions.ResourceIssues, THEME.palette.resourceIssues.dark.color],
]);
export var getColorOptions = function (_a) {
    var _b, _c;
    var color = _a.color, contrast = _a.contrast;
    var defaultColors = {
        contrast: THEME.palette.gray.smoke.color,
        color: THEME.palette.gray.slate.color,
    };
    if (contrast) {
        return (_b = MAPPED_CONTRAST_COLORS.get(color)) !== null && _b !== void 0 ? _b : defaultColors.contrast;
    }
    return (_c = MAPPED_COLORS.get(color)) !== null && _c !== void 0 ? _c : defaultColors.color;
};
